
import React from "react";
// import { useContext } from "react";
//import { useAuth } from "../../context/AuthContext";
//import { useNavigate } from "react-router-dom";
// import { ThemeContext } from "../../context/ThemeContext";
//import Logo from "../logo/Logo";
///import Image from "../image/Image";
import "./mainheader.css";
export default function MainHeader() {
 // const { user, logoutUser } = useAuth();
//  const navigate = useNavigate();
  // const theme = useContext(ThemeContext);
 // const ucWords = (str = "") =>
  //  str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
//  const fullName = ucWords(`${user.first_name ?? ""} ${user.last_name ?? ""}`).trim();

 /* const handleLogout = async () => {
    // Clear all local and session storage
    // localStorage.clear();
    // sessionStorage.clear();

    // If you only want to clear app-specific keys:
    // localStorage.removeItem("theme");
    // localStorage.removeItem("translations_1_en");
    // localStorage.removeItem("user");
    // sessionStorage.removeItem("authToken");

    // Call your logout service (API or auth context)
    await logoutUser();

    // Redirect to login page
    navigate("/login");
  }; */

  return (
    <div className="header-logo-area">
      {/* <div className="compny-logo">
        <Logo type="primary" size={196} />
      </div>
     
      <div className="logout-area">
        <div className="user-menu">
          <ul>
            <li>
              <div className="dashuserpf">
                <span>{fullName}</span>
                <span>
                  <img src={Image.userProfile} alt="" />
                </span>
              </div>
              <ul>
                <li>
                  <a href="/settings">My Settings</a>
                </li>
                <li>
                  <a
                    href="#"
                    role="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLogout();
                    }}
                  >
                    Log Out
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="profile-pic"></div>
      </div> */}

    </div>
  );
}
